import { ReactNode, createContext, useCallback, useState } from "react";
import { LoadingStateDefault } from "./Loading.constants";
import { LoadingState } from "./Loading.types";

export const LoadingContext = createContext<LoadingState>(LoadingStateDefault);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loadingCount, setLoadingCount] = useState<number>(0);

  const loading = loadingCount > 0;

  const setLoading = useCallback<React.Dispatch<React.SetStateAction<boolean>>>(
    (value) => {
      setLoadingCount((prev) => {
        const newLoadingState = typeof value === "function" ? value(prev > 0) : value;

        if (newLoadingState) {
          return prev + 1;
        } else {
          return Math.max(0, prev - 1);
        }
      });
    },
    [],
  );

  return (
    <LoadingContext.Provider
      value={{
        loading,
        setLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
